import { useTranslation } from 'react-i18next';
import { Plus, StickyNote } from 'lucide-react';
import { Button, ProcessFlowBottomToolbar, type CursorMode } from '@bliks-io/ui';

interface Props {
  onAutoLayout: () => Promise<unknown>;
  onUndo: () => void;
  onRedo: () => void;
  canUndo: boolean;
  canRedo: boolean;
  cursorMode: CursorMode;
  onCursorModeChange: (mode: CursorMode) => void;
  onAddStepCenter: () => void;
  onAddNoteCenter: () => void;
}

export function DraftEditorBottomToolbar({
  onAutoLayout,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  cursorMode,
  onCursorModeChange,
  onAddStepCenter,
  onAddNoteCenter
}: Props) {
  const { t } = useTranslation();
  return (
    <ProcessFlowBottomToolbar
      onAutoLayout={onAutoLayout}
      onUndo={onUndo}
      onRedo={onRedo}
      canUndo={canUndo}
      canRedo={canRedo}
      cursorMode={cursorMode}
      onCursorModeChange={onCursorModeChange}
    >
      <Button variant="ghost" size="small" onClick={onAddStepCenter} className="shadow-none">
        <Plus className="w-4 h-4 mr-1.5" />
        {t('processDraft.addStep')}
      </Button>
      <Button variant="ghost" size="small" onClick={onAddNoteCenter} className="shadow-none">
        <StickyNote className="w-4 h-4 mr-1.5" />
        {t('processDraft.addNote')}
      </Button>
    </ProcessFlowBottomToolbar>
  );
}
